export default __webpack_public_path__ + "static/media/PITA_logo_black.64328f5f.svg";